import { forwardRef } from "react";
import { DEFAULT_FLEX_PROPS } from "./Flex.constants.js";
import { FlexStyle } from "./Flex.style.js";
import { FlexProps } from "./Flex.types.js";

export const Flex = forwardRef<HTMLDivElement, FlexProps>((props, ref) => {
    const { children, ...attributes } = { ...DEFAULT_FLEX_PROPS, ...props };

    return (
        <FlexStyle {...attributes} ref={ref}>
            {children}
        </FlexStyle>
    );
});
